<script>
	import {External, M} from '../../external';

	export let contact;

	const addTag = () => {
		External.UITools.selectTagsExt({
			onTagsSelected: (tags) => {
				if (tags.length === 0) {
					return;
				}
				const selected = tags[0];

				if (contact.data.tags.filter((tag) => tag.first === selected.id).length > 0) {
					return;
				}

				External.Tools.makeWebsiteRequest({
					action: 'setContactTag',
					onOk: function () {
						contact.data.tags = [
							...contact.data.tags,
							{
								first: selected.id,
								second: selected.label
							}
						];
					},
					data: {
						id: selected.id,
						contact: contact.data.id,
						tagAction: 'add'
					}
				});
			},
			allowEmptySelection: true,
			single: true,
			message: M.SELECT_TAGS2
		});
	};

	const removeTag = (tagId) => {
		External.Tools.prompt(M.REMOVE_TAG, M.REMOVE_TAG_CONFIRM, function () {
			External.Tools.makeWebsiteRequest({
				action: 'setContactTag',
				data: {
					id: tagId,
					contact: contact.data.id,
					tagAction: 'delete'
				},
				onOk: function () {
					contact.data.tags = contact.data.tags.filter((tag) => tag.first !== tagId);
				}
			});
		});
	};
</script>

<label class="label profile-tags-wrapper">
	<div class="col20 f-left flex align-center space-between">
		<h4 class="f-left col20 t-left">{M.TAGS}</h4>
		<a class="small-button blue with-icon flex-none rounded-effect" on:click={addTag} style="display: inline-block;">
			{M.ADD_TAG}
		</a>
	</div>
	<div class="col20 f-left mt-10" data-role="tags">
		{#each contact.data.tags as tag}
			<div class="filter-option" data-id={tag.first}>
				<span>{tag.second}</span>
				<a
					class="filter-delete"
					on:click={() => {
            removeTag(tag.first);
          }}
					data-action="removeTag">
					<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="10px"
							 height="10px" viewBox="0 0 357 357" style="enable-background:new 0 0 357 357;" xml:space="preserve">
            <polygon
							points="357,35.7 321.3,0 178.5,142.8 35.7,0 0,35.7 142.8,178.5 0,321.3 35.7,357 178.5,214.2 321.3,357 357,321.3 214.2,178.5"></polygon>
          </svg>
				</a>
			</div>
		{/each}
	</div>
</label>
